<div class="container-fluid">
  <div class="row d-flex justify-content-center">
    <div class="col-md-4">
      <fdx-login-form
        [errorMessages]="responseErrors"
        (submitForm)="onSubmitForm($event)"
      ></fdx-login-form>
    </div>
  </div>
</div>

<fdx-loader [isLoading]="isLoading" [hasLoadingText]="false"></fdx-loader>
